export const MOSTRA_BANNERS = true
export const MOSTRA_PROMOCOES = false
export const MOSTRA_MARCAS = true
export const EMPLOYEES = 'Employees'
export const CLIENTES = 'Clients'
export const NAVIOS = 'Navios'
export const PRECISA_LOGAR = 'Você precisa estar logado para acessar este conteúdo!'
export const CAMINHO_FOTOS = ''
export const NOME_EMPRESA = 'Grifo Marine'
// export const CAMINHO_DOCUMENTOS = 'http://ftptrade.ddns.net/sultrade/api/documents'
// export const CAMINHO_DOCS = 'http://ftptrade.ddns.net/sultrade/api/documents/docs'
// export const CAMINHO_API = 'http://ftptrade.ddns.net/sultrade/api/employee/'
export const CAMINHO_DOCUMENTOS = 'https://traderotasagrope1.websiteseguro.com/grifo/documents'
export const CAMINHO_DOCS = 'https://traderotasagrope1.websiteseguro.com/grifo/documents/docs'
export const CAMINHO_API = 'https://grifo.tradesystem.cloud/api/employee/'
// export const CAMINHO_API = 'http://localhost:8000/employee/'
export const CAMINHO_INVOICES = 'https://traderotasagrope1.websiteseguro.com/grifo/documents/invoices'
export const CAMINHO_API_EXTERNO = 'https://grifo.tradesystem.cloud/api/employee/'
export const API_BANCO = 'https://api-ip.bb.com.br/pagamentos-lote/v1';

export const API_BANCO_GPS = '/lotes-gps';
export const API_BANCO_GPS_GET = '/lotes-gps/';

export const API_BANCO_GRU = '/pagamentos-gru';
export const API_BANCO_GRU_GET = '/lotes-gru/';

export const API_BANCO_DARF = '/lotes-darf-normal-preto';
export const API_BANCO_DARF_GET = '/lotes-darf-preto-normal/';

export const API_BANCO_TRANS = '/lotes-transferencias';
export const API_BANCO_TRANS_GET = '/beneficiarios/';

export const API_BANCO_BOL = '/lotes-boletos';
export const API_BANCO_BOL_GET = '/lotes-boletos/';

export const API_BANCO_CONVENIO = '/lotes-guias-codigo-barras';
export const API_BANCO_CONVENIO_GET = '/lotes-guias-codigo-barras/';

export const API_BANCO_PIX = '/lotes-transferencias-pix';
export const API_BANCO_PIX_GET = '/lotes-transferencias-pix';

export const API_LIBERAR = '/liberar-pagamentos';

export const URL_SIGISS = "https://riogrande.sigiss.com.br/riogrande/ws/sigiss_ws.php?wsdl";
export const URL_SOAPACTION = "http://tempuri.org/GerarNota";

export const URL_SIGISS_CANCELAMENTO = "https://riogrande.sigiss.com.br/riogrande/ws/sigiss_ws.php?wsdl";
export const URL_SOAPACTION_CANCELAMENTO = "http://tempuri.org/CancelarNota";

export const DESCONTOS_CONCEDIDOS = 371;
export const CAMBIO_LIQUIDAR = 2096;
